import React from 'react';
import { CaseContact } from '../../services/api';
import { Plus } from 'lucide-react';
import './ContactsTab.css';

interface ContactsTabProps {
  contacts: CaseContact[];
  onAddContact: () => void;
}

const ContactsTab: React.FC<ContactsTabProps> = ({ contacts, onAddContact }) => {
  return (
    <div className="contacts-section">
      <div className="contacts-header">
        <button onClick={onAddContact} className="add-contact-btn">
          <Plus size={18} />
          Add Contact
        </button>
      </div>
      <div className="contacts-grid">
        {!contacts || contacts.length === 0 ? (
          <div className="empty-state">No contacts available</div>
        ) : (
          contacts.map((contact) => (
            <div key={contact.contactId} className="contact-card">
              <h3>{contact.name}</h3>
              <p className="contact-role">{contact.role}</p>
              {contact.emails && contact.emails.length > 0 && (
                <div className="contact-detail">
                  <span className="contact-icon">📧</span>
                  <div className="contact-values">
                    {contact.emails.map((email, idx) => (
                      <span key={idx}>{email}</span>
                    ))}
                  </div>
                </div>
              )}
              {contact.phones && contact.phones.length > 0 && (
                <div className="contact-detail">
                  <span className="contact-icon">📞</span>
                  <div className="contact-values">
                    {contact.phones.map((phone, idx) => (
                      <span key={idx}>{phone}</span>
                    ))}
                  </div>
                </div>
              )}
              {contact.addresses && contact.addresses.length > 0 && (
                <div className="contact-detail">
                  <span className="contact-icon">📍</span>
                  <div className="contact-values">
                    {contact.addresses.map((address, idx) => (
                      <span key={idx}>{address}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ContactsTab;

